import React from 'react'
import { Link, Redirect } from 'react-router-dom'
import { Layout, Form, Icon, Input, Button, Divider, message } from 'antd'
import authService from '../services/authentication.service'
import { UserContext } from '../contexts/UserContext'

const { Header } = Layout

const urlParams = new URLSearchParams(window.location.search)
const username = urlParams.get('username')
const token = urlParams.get('token')

class JoinUsResetPasswordForm extends React.Component {
  state = {
    isPasswordReset: false,
  }

  componentDidMount() {
    this.validateToken()
  }

  validateToken = async () => {
    await authService.validateForgotPasswordToken(username, token)
  }

  handleSubmit = (e) => {
    e.preventDefault()
    this.props.form.validateFields(async (err, values) => {
      if (!err) {
        const res = await authService.resetJoinUsPassword(
          values.username,
          values.password,
          values.confirmPassword,
          token
        )
        if (res) {
          message.success('Your password has been reset')
          this.setState({ isPasswordReset: true })
        }
      }
    })
  }

  render() {
    const { isPasswordReset } = this.state
    const { getFieldDecorator } = this.props.form

    if (isPasswordReset) return <Redirect to="/joinus/login" />

    return (
      <Form onSubmit={this.handleSubmit} className="login-form register-form">
        <Form.Item>
          {getFieldDecorator('username', {
            initialValue: username,
            rules: [{ required: true, message: 'Please input your username!' }],
          })(
            <Input
              prefix={<Icon type="user" style={{ color: '#FFF' }} />}
              placeholder="Username"
              style={{ marginTop: '-5rem' }}
            />
          )}
        </Form.Item>
        <Form.Item>
          {getFieldDecorator('password', {
            rules: [{ required: true, message: 'Please input your Password!' }],
          })(
            <Input
              prefix={<Icon type="lock" style={{ color: '#FFF' }} />}
              type="password"
              placeholder="Password"
              style={{ marginTop: '-5rem' }}
            />
          )}
        </Form.Item>
        <Form.Item>
          {getFieldDecorator('confirmPassword', {
            rules: [
              { required: true, message: 'Please confirm your Password!' },
            ],
          })(
            <Input
              prefix={<Icon type="lock" style={{ color: '#FFF' }} />}
              type="password"
              placeholder="Confirm Password"
              style={{ marginTop: '-5rem' }}
            />
          )}
        </Form.Item>
        <Form.Item>
          <Button
            type="primary"
            size="large"
            shape="round"
            block={true}
            htmlType="submit"
            className="login-form-button"
            style={{ marginTop: '-6rem' }}
          >
            Reset Password
          </Button>
          <Link to="/joinus/login">
            <p className="cta-link" style={{ textAlign: 'center' }}>
              Back to Login Page
            </p>
          </Link>
        </Form.Item>
      </Form>
    )
  }
}

const WrappedJoinUsResetPasswordForm = Form.create({
  name: 'joinus_registration',
})(JoinUsResetPasswordForm)

const JoinUsResetPassword = () => {
  return (
    <Layout>
      <section id="login-page">
        <Header className="header">
          <div className="header__logo" />
        </Header>
        <content>
          <section id="login-content">
            <div className="cta">
              <h1>Reset Password</h1>
              <h3>Please enter your new password</h3>
            </div>
            <Divider type="vertical" />
            <div className="login-form-container registration-form-container">
              <WrappedJoinUsResetPasswordForm />
            </div>
          </section>
        </content>
      </section>
    </Layout>
  )
}

JoinUsResetPassword.contextType = UserContext

export default JoinUsResetPassword
